import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { formatPaymentRequestStatusLabel } from '#/modules/finMgmt/claims/helper/paymentRequestStatus';

const PaymentRequestStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatPaymentRequestStatusLabel(status)}
    size={size}
    className={className}
  />
);

PaymentRequestStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default PaymentRequestStatusBadge;
